import { render, staticRenderFns } from "./NewPicture.vue?vue&type=template&id=b6e84a7e&scoped=true&"
var script = {}
import style0 from "./NewPicture.vue?vue&type=style&index=0&id=b6e84a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e84a7e",
  null
  
)

export default component.exports